import axiosClient from '@/api/axios';

export const getFeConfig = async () => {
  const url = '/ATLAS_getfeconfig';
  const data: any = await axiosClient.get<{
    AIRLABS_API_KEY: string;
    FLIGHTAWARE_API_KEY: string;
    OPENAI_API_KEY: string;
  }>(url);
  if (!data) return;
  localStorage.setItem('FLIGHTAWARE_API_KEY', data?.FLIGHTAWARE_API_KEY);
};
